export const faPazien = {
    prefix: "far",
    iconName: "pazien",
    icon: [512, 512, [], "f142", "M184.93,326.76a62.15,62.15,0,1,1,62.15,62A62,62,0,0,1,184.93,326.76ZM512,228.37c-46.37-62.29-143.59-105.14-256-105.14S46.37,166.08,0,228.37c69.66-26.6,158.82-42.51,256-42.51S442.34,201.78,512,228.37Z"]
};
